import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import IndentedCardHeader from '../../../components/IndentedCardHeader/IndentedCardHeader';
import IndentedCardContent from '../../../components/IndentedCardContent/IndentedCardContent';
import ErrorDialog from '../../../components/ErrorDialog/ErrorDialog';
import FabWithText from '../../../components/FabWithText/FabWithText';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import BuildIcon from '@material-ui/icons/BuildOutlined';
import ReportProblemIcon from '@material-ui/icons/ReportProblemOutlined';
import HelpIcon from '@material-ui/icons/HelpOutline';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import AddIcon from '@material-ui/icons/Add';
import CheckIcon from '@material-ui/icons/CheckOutlined';
import Button from '@material-ui/core/Button';
import { RadioGroup } from 'material-ui-formik-components/RadioGroup';
import TimesField from '../../../components/Fields/TimesField/TimesField';
import FormikTextField from '../../../components/Fields/FormikTextField/FormikTextField';
import DeleteDialog from '../../../components/DeleteDialog/DeleteDialog';
import BaseDialog from '../../../components/BaseDialog/BaseDialog';
import SuggestionDialog from './SuggestionDialog/SuggestionDialog';
import Replace from '../../../components/Replace/Replace';
import ReplaceContact from '../../../components/Replace/ReplaceContact/ReplaceContact';
import ReplaceMaintenanceTerms from '../../../components/Replace/ReplaceMaintenanceTerms/ReplaceMaintenanceTerms';
import LoaderProgress from '../../../components/Loader/LoaderProgress/LoaderProgress';
import Requests from './Requests/Requests';
import Grid from '@material-ui/core/Grid';
import PhotoField from './PhotoField/PhotoField';
import ButtonRadioField from '../../../components/Fields/ButtonRadioField/ButtonRadioField';

import propertyApi from '../../../api/properties';
import photosApi from '../../../api/photos';
import { Formik, Field } from 'formik';
import { Wizard, Steps, Step } from 'react-albus';
import { find, get } from 'lodash-es';
import { object, string } from 'yup';
import Resizer from 'react-image-file-resizer';
import loadImage from 'blueimp-load-image';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

import {
  getString,
  getStringWithBreaks,
  iPhoneFriendlyButtonLabel,
} from '../../../helpers/stringHelpers.js';
import { countJobsRaisedToday } from '../../../helpers/workRequestHelpers.js';
import constants from '../../../constants.js';
const stringsComponent = 'workRequests';
const textFieldMaxLength = 250;
const overallCommentFieldMaxLength = 240;

class CreateRequestForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      requests: [],
      where: null,
      what: null,
      issue: null,
      why: null,
      photos: [],
      quarantinePhotos: [],
      lastPhoto: null,
      jobComments: '',
      preferredTimesAM: [],
      preferredTimesPM: [],
      dog: null,
      comments: '',
      acceptTOC: false,
      isLoading: false,
      hasError: false,
      photoProcessing: false,
      photoError: '',
      amenities: [],
      issues: [],
      causes: [],
      deleteOpen: false,
      dialogOpen: false,
      duplicateDialogOpen: false,
      duplicateReference: null,
      duplicateInState: false,
      jobToDelete: null,
      jobToDeleteWhere: null,
      jobToDeleteIssue: null,
      suggestion: null,
      termsDialogOpen: false,
      wait: 0,
      quarantinePhotoCount: 1,
      dropIn: null,
    };
    this.initialState = this.state;
    this.handleCreate = this.handleCreate.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleClear = this.handleClear.bind(this);
    this.handlePrevious = this.handlePrevious.bind(this);
    this.handlePreviousTimes = this.handlePreviousTimes.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDialogToggle = this.handleDialogToggle.bind(this);
    this.handleDuplicateDialogToggle =
      this.handleDuplicateDialogToggle.bind(this);
    this.handleIssueCancel = this.handleIssueCancel.bind(this);
    this.handlePetsCancel = this.handlePetsCancel.bind(this);
    this.handleDuplicateCancel = this.handleDuplicateCancel.bind(this);
    this.handleDialogNext = this.handleDialogNext.bind(this);
    this.handleConfirmDialog = this.handleConfirmDialog.bind(this);
    this.handleTermsDialogToggle = this.handleTermsDialogToggle.bind(this);
    this.handlePhotoDrop = this.handlePhotoDrop.bind(this);
    this.handlePhotoRemove = this.handlePhotoRemove.bind(this);
    this.deleteRequest = this.deleteRequest.bind(this);
    this.deleteCancel = this.deleteCancel.bind(this);
    this.checkJobDuplicates = this.checkJobDuplicates.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  componentDidUpdate() {
    const { setUnsaved, requestCreated } = this.props;
    const { hasError } = this.state;
    setUnsaved(requestCreated || hasError ? false : true);
  }

  handleCreate(goTo) {
    this.setState({
      where: null,
      what: null,
      issue: null,
      why: null,
      photos: [],
      quarantinePhotos: [],
      jobComments: '',
    });
    goTo();
  }

  handleRemove(i, e) {
    const { spaces } = this.props;
    const { requests, issues } = this.state;

    const request = requests[i];
    this.setState({
      deleteOpen: true,
      jobToDelete: i,
      jobToDeleteWhere: find(spaces, ['id', request.where]).name,
      jobToDeleteIssue: find(issues[request.what], ['id', request.issue]).name,
    });
    e.stopPropagation();
  }

  handleDialogToggle(suggestion = null) {
    this.setState({
      dialogOpen: !this.state.dialogOpen,
      ...(suggestion && { suggestion: suggestion }),
    });
  }

  handleDuplicateDialogToggle() {
    this.setState({
      duplicateDialogOpen: !this.state.duplicateDialogOpen,
    });
  }

  handleDialogNext(next) {
    this.handleDialogToggle();
    next();
  }

  handleConfirmDialog() {
    const { clearRequestCreated, goWorkRequests, refresh } = this.props;
    clearRequestCreated();
    goWorkRequests();
    refresh();
  }

  handlePetsCancel(go) {
    // Callback resets the step (and hence the form).
    // Should use resetForm/handleReset instead but couldn't get this working.
    this.setState(
      {
        dog: null,
      },
      () => {
        setTimeout(() => {
          go(-1);
          go(1);
          this.handleDialogToggle();
        }, 0);
      }
    );
  }

  handleIssueCancel(go) {
    this.setState(
      {
        issue: null,
      },
      () => {
        setTimeout(() => {
          go(-1);
          go(1);
          this.handleDialogToggle();
        }, 0);
      }
    );
  }

  handleDuplicateCancel(go) {
    this.setState(
      {
        issue: null,
      },
      () => {
        setTimeout(() => {
          go(-1);
          go(1);
          this.handleDuplicateDialogToggle();
        }, 0);
      }
    );
  }

  handleCancel(go, push, step) {
    const { requests } = this.state;

    // If requests have been added but the user is not on the job summary
    // step (step 6) then take user back to job summary step.
    if (
      requests.length &&
      step &&
      ['where', 'what', 'issue', 'why', 'jobComments'].includes(step.id)
    ) {
      push('jobSummary');
      this.scrollToTop();
    } else {
      go();
    }
  }

  handleTermsDialogToggle() {
    this.setState({
      termsDialogOpen: !this.state.termsDialogOpen,
    });
  }

  deleteRequest() {
    this.setState({
      requests: this.state.requests.filter(
        (request, index) => index !== this.state.jobToDelete
      ),
      deleteOpen: false,
    });
  }

  deleteCancel() {
    this.setState({
      deleteOpen: !this.state.deleteOpen,
    });
  }

  checkJobDuplicates(issue) {
    const { spaces, createdWorkRequests, openWorkRequests } = this.props;

    const { where, what, amenities, issues } = this.state;

    let openJobs = [];
    openWorkRequests.forEach((request) => {
      if (request.raisedBy == 'MyKāingaOra') {
        openJobs.push(
          ...request.jobs.map((job) => {
            return { ...job, referenceNumber: request.referenceNumber };
          })
        );
      }
    });
    const currentRequests = this.state.requests;
    const currentRequest = {
      whereId: where,
      whatId: what,
      issueId: issue,
      where: find(spaces, ['id', where]).name,
      what: find(amenities[where], ['id', what]).name,
      issue: find(issues[what], ['id', issue]).name,
    };
    // Check duplicates within current jobs, jobs made previously in this
    // session and open jobs raised by MyKāingaOra (pulled from API).
    let duplicateInState = false;
    let match =
      find(currentRequests, {
        where: currentRequest.whereId,
        what: currentRequest.whatId,
        issue: currentRequest.issueId,
      }) ||
      find(openJobs, {
        location: currentRequest.where,
        amenity: currentRequest.what,
        issue: currentRequest.issue,
      });
    if (!match) {
      match = find(createdWorkRequests.jobs, {
        space: currentRequest.whereId,
        amenity: Number(currentRequest.whatId),
        issue: Number(currentRequest.issueId),
      });
      duplicateInState = true;
    }
    if (match) {
      // If job match has a reference number this will be displayed to the user.
      this.setState({
        duplicateReference: match.referenceNumber
          ? match.referenceNumber
          : null,
        duplicateInState: duplicateInState,
      });
    }
    return match;
  }

  handleClear(setFieldValue, name, e) {
    setFieldValue([name], '', true);
    // @TODO: Use refs to set the focus.
    document.getElementsByName(name)[0].focus();
  }

  handlePrevious(previous, key, value, maxLength) {
    this.setState({
      [key]: value ? value.trim().substring(0, maxLength) : value,
    });
    previous();
  }

  handlePreviousTimes(previous, values) {
    this.setState({
      preferredTimesAM: values.preferredTimesAM,
      preferredTimesPM: values.preferredTimesPM,
    });
    previous();
  }

  handlePhotoDrop(files) {
    this.handlePhotoRemove();
    if (files.length > 0) {
      const options = {
        noRevoke: true,
        canvas: true,
        meta: true,
        orientation: true,
        maxWidth: 1280,
        maxHeight: 720,
      };
      files.forEach((file) => {
        this.setState({
          photoProcessing: true,
          photoError: '',
        });

        // Resize image as a canvas element.
        loadImage(
          file,
          (img, data) => {
            // If image has EXIF data, store the data we are interested in.
            let metadata = {};
            if (data.exif) {
              const exifData = data.exif.getAll();
              if (exifData.DateTime) {
                metadata.DateTime = exifData.DateTime;
              }
            }
            // Convert canvas image to blob.
            img.toBlob((file) => {
              // Set image format and quality.
              const resampledImage = img.toDataURL('image/jpeg', 0.9);
              photosApi
                .checkPhoto(resampledImage)
                .then((response) => {
                  const {
                    encrypted,
                    hash,
                    labels,
                    text,
                    threats,
                    quarantine,
                    quarantineReason,
                  } = response.data;
                  // Store quarantined and accepted photos seperately.
                  const { quarantinePhotos } = this.state;
                  const photosKey = quarantine ? 'quarantinePhotos' : 'photos';
                  const currentPhotos =
                    photosKey == 'quarantinePhotos' ? quarantinePhotos : [];

                  const photoObjectUrl = URL.createObjectURL(file);
                  this.setState({
                    [photosKey]: [
                      {
                        file: resampledImage,
                        preview: photoObjectUrl,
                        encrypted: encrypted,
                        hash: hash,
                        labels: labels,
                        metadata: metadata,
                        text: text,
                        threats: threats,
                        quarantine: quarantine,
                        quarantineReason: quarantineReason,
                      },
                      ...currentPhotos,
                    ],
                    photoProcessing: false,
                    photoError: quarantine ? quarantineReason : '',
                    lastPhoto: photoObjectUrl,
                  });

                  if (quarantine) {
                    const { where, what, issue } = this.state;

                    const { tenancy } = this.props;
                    const { propertyReference, tenancyRef } =
                      tenancy.data.currentTenancy;

                    const photoData = {
                      file: resampledImage,
                      space: where,
                      amenityId: what,
                      issueId: issue,
                      objects: labels,
                      text: text,
                      quarantine: quarantine,
                      metadata: metadata,
                      threats: threats,
                      tenancyReference: tenancyRef,
                      hash: hash,
                      photoCount: this.state.quarantinePhotoCount,
                      encrypted: encrypted,
                    };

                    this.setState({
                      quarantinePhotoCount: this.state.quarantinePhotoCount + 1,
                    });

                    propertyApi.uploadPhoto(propertyReference, photoData);
                  }
                })
                .catch((err) => {
                  const wait = get(err, 'response.data._wait', 0);

                  this.setState({
                    photoProcessing: false,
                    photoError: err.response.data['_reason'],
                    wait: wait,
                    lastPhoto: URL.createObjectURL(file),
                  });

                  if (wait) {
                    const waitTimer = setInterval(() => {
                      this.setState({
                        wait: this.state.wait - 1,
                      });
                      if (this.state.wait <= 0) {
                        clearInterval(waitTimer);
                      }
                    }, 1000);
                  }
                });
            });
          },
          options
        );
      });
    } else {
      this.setState({
        photoError: 'invalidmimetype',
      });
    }
  }

  handlePhotoRemove() {
    this.setState({
      photos: [],
      photoError: '',
      lastPhoto: null,
    });
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  getPhotoErrorMessage(photoError) {
    let message;

    switch (photoError) {
      case '':
        message = '';
        break;
      case 'notaccepted':
        message = getString(stringsComponent, 'PHOTO_ERROR_UNACCEPTABLE');
        break;
      case 'facedetected':
        message = getString(stringsComponent, 'PHOTO_ERROR_FACE');
        break;
      case 'texttoolong':
        message = getString(stringsComponent, 'PHOTO_ERROR_TEXT_LENGTH');
        break;
      case 'phototoolarge':
        message = getString(stringsComponent, 'PHOTO_ERROR_SIZE');
        break;
      case 'invalidmimetype':
        message = getString(stringsComponent, 'PHOTO_ERROR_MIME');
        break;
      case 'pleasewait':
        if (this.state.wait > 0) {
          message = getString(
            stringsComponent,
            'PHOTO_ERROR_PLEASE_WAIT'
          ).replace('{wait}', this.state.wait);
        } else {
          message = getString(stringsComponent, 'PHOTO_ERROR_PLEASE_TRY_AGAIN');
        }
        break;
      default:
        message = getString(stringsComponent, 'PHOTO_ERROR_DEFAULT');
    }
    return message;
  }

  buildCardHeader(title) {
    const { classes } = this.props;
    return (
      <IndentedCardHeader
        title={<Typography variant="h3">{title}</Typography>}
        avatar={<BuildIcon />}
        classes={{
          title: classes.title,
          avatar: classes.avatar,
        }}
      />
    );
  }

  buildButtons(
    submitHandler,
    previous = null,
    isValid = true,
    push = null,
    step = null,
    nextButtonLabel = 'Next'
  ) {
    const { classes, goWorkRequests, gaEvent } = this.props;
    return (
      <Grid container className={classes.buttons}>
        <Grid item xs={4}>
          <Button
            variant="outlined"
            onClick={() => this.handleCancel(goWorkRequests, push, step)}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item xs={8} className={classes.buttonsRight}>
          <React.Fragment>
            {previous && (
              <Button
                variant="outlined"
                onClick={() => {
                  previous();
                  this.scrollToTop();
                }}
                className={'backButton'}
              >
                Back
              </Button>
            )}
            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                submitHandler();
                this.scrollToTop();
                nextButtonLabel === 'Submit' &&
                  gaEvent('Maintenance', 'Click', 'Confirm and Submit');
              }}
              disabled={!isValid}
              className={classes.buttonsNext}
            >
              {iPhoneFriendlyButtonLabel(nextButtonLabel, !isValid)}
            </Button>
          </React.Fragment>
        </Grid>
      </Grid>
    );
  }

  /**
   * Build radio button form .
   * @param {string} cardTitle Card/form title.
   * @param {Object} initialValues Initial form values.
   * @param {string} fieldName Field name (should correspond to both state and field name).
   * @param {string} fieldLabel Field label.
   * @param {Array} options Array of option objects.
   * @param {callback} next What to do as the last step of form submission.
   * @param {callback|null} callback A callback to an API function. Used to set the state for the options of the next step.
   * @param {boolean} isTree Whether the options retrieved from the callback are a tree structure.
   * @param {string|null} state The key of the state to set with the data returned from the callback.
   * @param {callback|null} previous  What to do when the back button is pushed.
   * @param {string|null} resetState The key of the state to reset upon callback (intended to be the state used in the next step).
   * @param {callback|null} push Callback to a function that can control the step the user is on.
   * @param {string|null} step The current step of the wizard the user is on.
   * @param {Object|null} dialog Optional dialog.
   * @param {boolean} duplicateCheck Whether this form should perform the duplicate check.
   * @returns {Object}
   */
  buildForm(
    cardTitle,
    initialValues,
    fieldName,
    fieldLabel,
    options,
    next,
    callback = null,
    isTree = false,
    state = null,
    previous = null,
    resetState = null,
    push = null,
    step = null,
    dialog = null,
    duplicateDialog = null
  ) {
    const { classes } = this.props;

    const validationSchema = object().shape({
      [fieldName]: string().required('Required'),
    });

    return (
      <React.Fragment>
        {this.buildCardHeader(cardTitle)}
        {dialog}
        {duplicateDialog}
        <IndentedCardContent
          body={
            <div className={classes.negativeTopMargin}>
              <Divider />
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                isInitialValid={validationSchema.isValidSync(initialValues)}
                onSubmit={(values, { setSubmitting }) => {
                  if (
                    duplicateDialog &&
                    this.checkJobDuplicates(values.issue)
                  ) {
                    this.handleDuplicateDialogToggle();
                  } else {
                    if (callback && state) {
                      function goNextOrToggleDialog(handleDialogToggle) {
                        setSubmitting(false);
                        const suggestion = find(
                          portalSuggestions,
                          (suggestion) => {
                            return suggestion.issues.includes(
                              Number(values[fieldName])
                            );
                          }
                        );
                        if (dialog && suggestion && resetOptions) {
                          handleDialogToggle(suggestion.key);
                        } else {
                          next();
                        }
                      }
                      // Reset the state of the next step if the current value changed.
                      const resetOptions =
                        this.state[fieldName] != values[fieldName];
                      this.setState({
                        ...(resetOptions &&
                          resetState && { [resetState]: null }),
                        ...values,
                      });
                      if (
                        this.state[state][this.state[fieldName]] ||
                        (!isTree && this.state[state].length > 0)
                      ) {
                        goNextOrToggleDialog(this.handleDialogToggle);
                      } else {
                        this.setState({ isLoading: true });
                        callback(this.state[fieldName])
                          .then((resp) => {
                            this.setState({
                              [state]: isTree
                                ? {
                                    ...this.state[state],
                                    [this.state[fieldName]]: resp.data[state],
                                  }
                                : resp.data[state],
                              isLoading: false,
                            });
                          })
                          .catch((err) => {
                            this.setState({ hasError: true });
                          })
                          .then(() => {
                            goNextOrToggleDialog(this.handleDialogToggle);
                          });
                      }
                    } else {
                      if (
                        dialog &&
                        values[fieldName] == 'true' &&
                        values[fieldName] != this.state[fieldName]
                      ) {
                        this.setState({
                          ...values,
                          dialogOpen: true,
                        });
                      } else {
                        this.setState({
                          ...values,
                        });
                        next();
                      }
                    }
                  }
                }}
              >
                {(props) => {
                  const { handleChange, handleSubmit, isValid } = props;
                  return (
                    <form>
                      {this.buildRadioField(
                        fieldName,
                        fieldLabel,
                        options,
                        handleChange,
                        handleSubmit
                      )}
                      {this.buildButtons(
                        handleSubmit,
                        previous,
                        isValid,
                        push,
                        step
                      )}
                    </form>
                  );
                }}
              </Formik>
            </div>
          }
        />
      </React.Fragment>
    );
  }

  buildRadioField(name, label, options, changeHandler, submitHandler) {
    const { classes } = this.props;

    let opt = [];
    if (options) {
      options.forEach((item) => opt.push({ label: item.name, value: item.id }));
    }

    return (
      <Field
        name={name}
        label={label}
        component={RadioGroup}
        options={opt}
        classes={{
          formControl: `${classes.formControl} ${classes.requiredField}`,
        }}
      />
    );
  }

  renderWhereStep(next, push, step) {
    const { spaces } = this.props;

    const { where } = this.state;

    return this.buildForm(
      getString(stringsComponent, 'WHERE_STEP_TITLE'),
      { where: where ? where : '' },
      'where',
      `${getString(stringsComponent, 'WHERE_STEP_LABEL')}`,
      spaces,
      next,
      propertyApi.getAmenities,
      true,
      'amenities',
      null,
      'what',
      push,
      step
    );
  }

  renderWhatStep(next, push, step, previous) {
    const { what, amenities, where } = this.state;

    return this.buildForm(
      getString(stringsComponent, 'WHAT_STEP_TITLE'),
      { what: what ? what : '' },
      'what',
      `${getString(stringsComponent, 'WHAT_STEP_LABEL')}`,
      amenities[where],
      next,
      propertyApi.getIssues,
      true,
      'issues',
      previous,
      'issue',
      push,
      step
    );
  }

  renderIssueStep(next, push, step, previous, go) {
    const { contactAction } = this.props;

    const {
      issue,
      issues,
      amenities,
      where,
      what,
      dialogOpen,
      duplicateDialogOpen,
      duplicateReference,
      duplicateInState,
      suggestion,
    } = this.state;

    return this.buildForm(
      getString(stringsComponent, 'ISSUE_STEP_TITLE'),
      { issue: issue ? issue : '' },
      'issue',
      `${getString(stringsComponent, 'ISSUE_STEP_LABEL').replace(
        '{amenity}',
        find(amenities[where], ['id', what]).name.toLowerCase()
      )}`,
      issues[what],
      next,
      propertyApi.getCauses,
      false,
      'causes',
      previous,
      'why',
      push,
      step,
      <SuggestionDialog
        open={dialogOpen}
        icon={HelpIcon}
        buttonAction={() => this.handleDialogNext(next)}
        buttonLabel={getString(stringsComponent, 'DIALOG_NEXT_BUTTON')}
        secondaryButtonAction={() => this.handleIssueCancel(go)}
        secondaryButtonLabel={getString(stringsComponent, 'DIALOG_BACK_BUTTON')}
        title={'Try This First'}
        summary={
          <ReplaceContact
            content={suggestion ? portalSuggestions[suggestion].summary : ''}
            action={contactAction}
            forceEnglish={true}
            isLink={true}
          />
        }
        details={
          <ReplaceContact
            content={suggestion ? portalSuggestions[suggestion].details : ''}
            action={contactAction}
            forceEnglish={true}
            isLink={true}
          />
        }
        expansionTitle={
          suggestion ? portalSuggestions[suggestion].expansionTitle : ''
        }
        expansionContent={
          <ReplaceContact
            content={
              suggestion ? portalSuggestions[suggestion].expansionContent : ''
            }
            action={contactAction}
            forceEnglish={true}
            isLink={true}
          />
        }
      />,
      <BaseDialog
        open={duplicateDialogOpen}
        icon={ErrorIcon}
        buttonAction={() => this.handleDuplicateCancel(go)}
        buttonLabel={getString(stringsComponent, 'DIALOG_CLOSE_BUTTON')}
        title={getString(stringsComponent, 'ISSUE_STEP_DUPLICATE_TITLE')}
        content={
          duplicateReference ? (
            <Replace
              content={getString(stringsComponent, 'ISSUE_STEP_DUPLICATE_OPEN')}
              toReplace="$Reference"
              replaceWith={String(duplicateReference)}
            />
          ) : duplicateInState ? (
            getString(stringsComponent, 'ISSUE_STEP_DUPLICATE_IN_STATE')
          ) : (
            getString(stringsComponent, 'ISSUE_STEP_DUPLICATE_CURRENT')
          )
        }
      />
    );
  }

  renderWhyStep(next, push, step, previous) {
    const { why, causes } = this.state;
    return this.buildForm(
      getString(stringsComponent, 'WHY_STEP_TITLE'),
      { why: why ? why : '' },
      'why',
      `${getString(stringsComponent, 'WHY_STEP_LABEL')}`,
      causes,
      next,
      null,
      false,
      null,
      previous,
      null,
      push,
      step
    );
  }

  renderPhotoStep(next, push, step, previous) {
    const { classes, spaces } = this.props;

    const {
      photos,
      lastPhoto,
      amenities,
      where,
      what,
      photoProcessing,
      photoError,
    } = this.state;
    return (
      <React.Fragment>
        {this.buildCardHeader('Step 5/10 | Job Photos')}
        <IndentedCardContent
          body={
            <div className={classes.negativeTopMargin}>
              <Divider />
              <Formik
                initialValues={{
                  photos: photos,
                }}
                isInitialValid={photos}
                onSubmit={(values, { setSubmitting }) => {
                  setSubmitting(false);
                  next();
                }}
              >
                {(props) => {
                  const { handleSubmit } = props;
                  return (
                    <form>
                      <Typography
                        variant="body1"
                        className={classes.jobCommentsLabel}
                      >
                        {photos.length
                          ? getString(stringsComponent, 'PHOTO_STEP_HELP_ALT')
                          : getString(stringsComponent, 'PHOTO_STEP_HELP')
                              .replace(
                                '{what}',
                                find(amenities[where], [
                                  'id',
                                  what,
                                ]).name.toLowerCase()
                              )
                              .replace(
                                '{where}',
                                find(spaces, ['id', where]).name.toLowerCase()
                              )}
                      </Typography>
                      <PhotoField
                        onDrop={this.handlePhotoDrop}
                        removeAction={this.handlePhotoRemove}
                        files={photos}
                        downloadLink={lastPhoto}
                        photoProcessing={photoProcessing}
                        error={this.getPhotoErrorMessage(photoError)}
                      />
                      <Typography
                        variant="body1"
                        className={classes.jobCommentsLabel}
                      >
                        <ReplaceMaintenanceTerms
                          content={getString(
                            stringsComponent,
                            'PHOTO_STEP_PRIVACY'
                          )}
                          action={this.handleTermsDialogToggle}
                        />
                      </Typography>
                      {this.buildButtons(
                        handleSubmit,
                        () => {
                          previous();
                        },
                        !photoProcessing,
                        push,
                        step
                      )}
                    </form>
                  );
                }}
              </Formik>
            </div>
          }
        />
      </React.Fragment>
    );
  }

  renderJobCommentsStep(next, push, step, previous) {
    const { classes } = this.props;

    const {
      jobComments,
      requests,
      where,
      what,
      issue,
      why,
      photos,
      quarantinePhotos,
    } = this.state;
    return (
      <React.Fragment>
        {this.buildCardHeader(
          getString(stringsComponent, 'JOB_COMMENTS_STEP_TITLE')
        )}
        <IndentedCardContent
          body={
            <div className={classes.negativeTopMargin}>
              <Divider />
              <Formik
                initialValues={{
                  jobComments: jobComments,
                }}
                isInitialValid={
                  jobComments && jobComments.length > textFieldMaxLength
                    ? false
                    : true
                }
                onSubmit={(values, { setSubmitting }) => {
                  this.setState({
                    ...values,
                    requests: [
                      ...requests,
                      {
                        where: where,
                        what: what,
                        issue: issue,
                        why: why,
                        photos: photos,
                        quarantinePhotos: quarantinePhotos,
                        jobComments: values.jobComments
                          .trim()
                          .substring(0, textFieldMaxLength),
                      },
                    ],
                  });
                  setSubmitting(false);
                  next();
                }}
              >
                {(props) => {
                  const { values, handleSubmit, isValid, setFieldValue } =
                    props;
                  return (
                    <form>
                      <Typography
                        variant="body1"
                        className={classes.jobCommentsLabel}
                      >
                        {getString(stringsComponent, 'JOB_COMMENTS_STEP_LABEL')}
                      </Typography>
                      <FormikTextField
                        name="jobComments"
                        value={values.jobComments
                          .replace('|', '')
                          .substring(0, textFieldMaxLength)}
                        label={getString(
                          stringsComponent,
                          'JOB_COMMENTS_STEP_PLACEHOLDER'
                        )}
                        maxLength={textFieldMaxLength}
                        clear={(e) => {
                          this.handleClear(setFieldValue, 'jobComments', e);
                        }}
                        className={classes.jobCommentsInput}
                        classes={{
                          label: classes.jobCommentsInput,
                          input: classes.jobCommentsInput,
                        }}
                      />
                      <Typography
                        variant="body2"
                        className={classes.jobCommentsHelpText}
                      >
                        {getString(stringsComponent, 'JOB_COMMENTS_STEP_HELP')}
                      </Typography>
                      <Typography
                        variant="body2"
                        className={classes.jobCommentsHelpText}
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: getString(
                              stringsComponent,
                              'JOB_COMMENTS_STEP_HELP_LIST'
                            ),
                          }}
                        />
                      </Typography>
                      {this.buildButtons(
                        handleSubmit,
                        () => {
                          this.handlePrevious(
                            previous,
                            'jobComments',
                            values.jobComments,
                            textFieldMaxLength
                          );
                        },
                        isValid,
                        push,
                        step
                      )}
                    </form>
                  );
                }}
              </Formik>
            </div>
          }
        />
      </React.Fragment>
    );
  }

  renderJobSummaryStep(next, push, step) {
    const { classes, spaces, workRequests, createdWorkRequests } = this.props;

    const {
      deleteOpen,
      jobToDelete,
      jobComments,
      requests,
      amenities,
      issues,
      causes,
      jobToDeleteWhere,
      jobToDeleteIssue,
    } = this.state;

    const request = Number.isInteger(jobToDelete) && requests[jobToDelete];
    const openWorkRequestsData = get(workRequests, 'open.data', []);
    const createdJobsCount = createdWorkRequests.jobs
      ? createdWorkRequests.jobs.length
      : 0;
    const jobsRaisedTodayCount = countJobsRaisedToday(openWorkRequestsData);

    return (
      <React.Fragment>
        <DeleteDialog
          open={deleteOpen}
          cancel={this.deleteCancel}
          deleteContact={this.deleteRequest}
          subject={
            request ? (
              <React.Fragment>
                <strong className={classes.bold}>
                  {jobToDeleteWhere}
                  {': '}
                </strong>
                {jobToDeleteIssue}
              </React.Fragment>
            ) : null
          }
          dialogContent={getString(stringsComponent, 'DELETE_JOB_MESSAGE')}
        />
        {this.buildCardHeader(
          getString(stringsComponent, 'JOB_SUMMARY_STEP_TITLE')
        )}
        <IndentedCardContent
          body={
            <div className={classes.negativeTopMargin}>
              <Divider />
              <Formik
                initialValues={{
                  jobComments: jobComments,
                }}
                onSubmit={(values, { setSubmitting }) => {
                  this.setState({
                    ...values,
                  });
                  setSubmitting(false);
                  next();
                }}
                isInitialValid={true}
              >
                {(props) => {
                  const { handleSubmit } = props;
                  return (
                    <form>
                      <Typography
                        variant="body1"
                        className={classes.jobSummaryLabel}
                      >
                        {getStringWithBreaks(
                          stringsComponent,
                          'JOB_SUMMARY_STEP_LABEL'
                        )}
                      </Typography>
                      <Requests
                        requests={requests}
                        spaces={spaces}
                        amenities={amenities}
                        issues={issues}
                        causes={causes}
                        handleRemove={this.handleRemove}
                      />
                      {requests.length >= constants.JOBS_PER_REQUEST_LIMIT ||
                      createdJobsCount +
                        requests.length +
                        jobsRaisedTodayCount >=
                        constants.DAILY_REQUEST_LIMIT ? (
                        <Typography
                          className={classes.jobSummaryLimit}
                          component="p"
                          variant="h4"
                        >
                          {getString(
                            stringsComponent,
                            'JOB_SUMMARY_STEP_LIMIT_TEXT'
                          )}
                        </Typography>
                      ) : (
                        <FabWithText
                          label={getString(
                            stringsComponent,
                            'CREATE_BUTTON_LABEL'
                          )}
                          action={() => {
                            this.scrollToTop();
                            this.handleCreate(() => push('where'));
                          }}
                          icon={AddIcon}
                          ariaLabel="Create"
                        />
                      )}
                      {this.buildButtons(
                        handleSubmit,
                        null,
                        requests.length > 0,
                        push,
                        step
                      )}
                    </form>
                  );
                }}
              </Formik>
            </div>
          }
        />
      </React.Fragment>
    );
  }

  renderTimesStep(next, push, step, previous) {
    const { preferredTimesAM, preferredTimesPM } = this.state;

    const { classes } = this.props;

    // Conditional validation from https://github.com/jquense/yup/issues/176#issuecomment-369925782
    const preferredTimesSchema = object().shape(
      {
        preferredTimesAM: string().when(['preferredTimesPM'], {
          is: (preferredTimesPM) => !preferredTimesPM,
          then: string().required(),
        }),
        preferredTimesPM: string().when(['preferredTimesAM'], {
          is: (preferredTimesAM) => !preferredTimesAM,
          then: string().required(),
        }),
      },
      [['preferredTimesAM', 'preferredTimesPM']]
    );

    const preferredTimes = [
      { id: 'mon', name: 'Monday' },
      { id: 'tue', name: 'Tuesday' },
      { id: 'wed', name: 'Wednesday' },
      { id: 'thu', name: 'Thursday' },
      { id: 'fri', name: 'Friday' },
    ];

    return (
      <React.Fragment>
        {this.buildCardHeader(getString(stringsComponent, 'TIMES_STEP_TITLE'))}
        <IndentedCardContent
          body={
            <div className={classes.negativeTopMargin}>
              <Divider />
              <Formik
                initialValues={{
                  preferredTimesAM: preferredTimesAM,
                  preferredTimesPM: preferredTimesPM,
                }}
                onSubmit={(values, { setSubmitting }) => {
                  this.setState({
                    preferredTimesAM: values.preferredTimesAM,
                    preferredTimesPM: values.preferredTimesPM,
                  });
                  setSubmitting(false);
                  next();
                }}
                validationSchema={preferredTimesSchema}
                isInitialValid={
                  preferredTimesAM.length || preferredTimesPM.length
                }
              >
                {(props) => {
                  const { values, handleSubmit, isValid } = props;

                  const radioOptions = [
                    {
                      value: 'yes',
                      label: getString(stringsComponent, 'YES_LABEL'),
                    },
                    {
                      value: 'no',
                      label: getString(stringsComponent, 'NO_LABEL'),
                    },
                  ];

                  return (
                    <form>
                      <Typography
                        variant="body1"
                        className={classes.jobCommentsLabel}
                      >
                        <span className={classes.requiredField}>
                          <span className={`label`}>
                            {getString(stringsComponent, 'TIMES_STEP_LABEL')}
                          </span>
                        </span>
                      </Typography>
                      <div className={classes.timeFieldContainer}>
                        <Grid container className={classes.timeFieldHeader}>
                          <Grid item xs={2} />
                          <Grid
                            item
                            xs={2}
                            className={classes.availabilityColumn}
                          >
                            <Typography variant="body1">M</Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            className={classes.availabilityColumn}
                          >
                            <Typography variant="body1">T</Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            className={classes.availabilityColumn}
                          >
                            <Typography variant="body1">W</Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            className={classes.availabilityColumn}
                          >
                            <Typography variant="body1">T</Typography>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            className={classes.availabilityColumn}
                          >
                            <Typography variant="body1">F</Typography>
                          </Grid>
                        </Grid>
                        <TimesField
                          fieldName="preferredTimesAM"
                          preferredTimes={preferredTimes}
                          value={values.preferredTimesAM}
                          label="AM"
                        />
                        <TimesField
                          fieldName="preferredTimesPM"
                          preferredTimes={preferredTimes}
                          value={values.preferredTimesPM}
                          label="PM"
                        />
                      </div>
                      <Typography className={classes.jobCommentsHelpText}>
                        {getString(stringsComponent, 'TIMES_STEP_HELP')}
                      </Typography>
                      <br />
                      <br />

                      <Typography>
                        {getString(stringsComponent, 'DROP_IN_QUESTION')}
                      </Typography>
                      <br />

                      <ButtonRadioField
                        fieldName={'noDropIn'}
                        value={
                          this.state.dropIn === null
                            ? null
                            : this.state.dropIn === true
                            ? 'yes'
                            : 'no'
                        }
                        onChange={(event) => {
                          this.setState({
                            dropIn: event.target.value === 'yes' ? true : false,
                          });
                        }}
                        options={radioOptions}
                      />

                      {this.buildButtons(
                        handleSubmit,
                        () => {
                          this.handlePreviousTimes(previous, values);
                        },
                        isValid && this.state.dropIn !== null,
                        push,
                        step
                      )}
                    </form>
                  );
                }}
              </Formik>
            </div>
          }
        />
      </React.Fragment>
    );
  }

  renderPetsStep(next, previous, go) {
    const { classes } = this.props;

    const { dog, dialogOpen } = this.state;

    return this.buildForm(
      getString(stringsComponent, 'PETS_STEP_TITLE'),
      { dog: dog },
      'dog',
      `${getString(stringsComponent, 'PETS_STEP_LABEL')}`,
      [
        {
          id: 'true',
          name: getString(stringsComponent, 'PETS_STEP_HAS_DOG'),
        },
        {
          id: 'false',
          name: getString(stringsComponent, 'PETS_STEP_NO_DOG'),
        },
      ],
      next,
      null,
      false,
      null,
      previous,
      null,
      null,
      null,
      <BaseDialog
        open={dialogOpen}
        icon={ReportProblemIcon}
        buttonAction={() => this.handleDialogNext(next)}
        buttonLabel={getString(stringsComponent, 'DIALOG_NEXT_BUTTON')}
        secondaryButtonAction={() => this.handlePetsCancel(go)}
        secondaryButtonLabel={getString(stringsComponent, 'DIALOG_BACK_BUTTON')}
        title={getString(stringsComponent, 'PETS_STEP_DIALOG_TITLE')}
        content={
          <React.Fragment>
            <Typography gutterBottom className={classes.dialogText}>
              {getString(stringsComponent, 'PETS_STEP_DIALOG_TEXT_1')}
            </Typography>
            <Typography>
              {getString(stringsComponent, 'PETS_STEP_DIALOG_TEXT_2')}
            </Typography>
          </React.Fragment>
        }
        contentWrap={false}
      />
    );
  }

  renderCommentsStep(push, step, previous) {
    const {
      classes,
      contactAction,
      requestCreated,
      createWorkRequest,
      createdWorkRequests,
      customerIsolating,
    } = this.props;

    const {
      comments,
      requests,
      acceptTOC,
      preferredTimesAM,
      preferredTimesPM,
      dog,
      dropIn,
    } = this.state;

    return (
      <React.Fragment>
        <BaseDialog
          open={requestCreated}
          icon={CheckIcon}
          buttonAction={this.handleConfirmDialog}
          buttonLabel={getString(stringsComponent, 'DIALOG_CLOSE_BUTTON')}
          title={getString(stringsComponent, 'CONFIRM_DIALOG_TITLE')}
          content={
            <ReplaceContact
              content={
                createdWorkRequests.photoFailed
                  ? portalContent.MAINTENANCE_CONFIRMED_ERROR
                  : portalContent.MAINTENANCE_CONFIRMED
              }
              action={contactAction}
              forceEnglish={true}
              isLink={true}
            />
          }
          contentWrap={false}
          isHTML={true}
          centre={true}
        />
        {this.buildCardHeader(
          getString(stringsComponent, 'CONFIRM_STEP_TITLE')
        )}
        <IndentedCardContent
          body={
            <div className={classes.negativeTopMargin}>
              <Divider />
              <Formik
                initialValues={{
                  comments: comments,
                }}
                isInitialValid={
                  comments && comments.length > overallCommentFieldMaxLength
                    ? false
                    : true
                }
                onSubmit={(values, { setSubmitting }) => {
                  this.setState({
                    comments: values.comments
                      .trim()
                      .substring(0, overallCommentFieldMaxLength),
                    acceptTOC: values.acceptTOC,
                    isLoading: true,
                  });
                  setSubmitting(true);
                  let jobs = [];
                  requests.forEach((request) => {
                    jobs.push({
                      space: request.where,
                      amenity: Number(request.what),
                      issue: Number(request.issue),
                      causedBy: request.why,
                      comments: request.jobComments,
                      photos: request.photos,
                    });
                  });
                  const data = {
                    termsAgreed: true, // This should always be true, agreement to terms is implied by submitting maintenance request
                    preferredTimes: {
                      ...(preferredTimesAM.length && {
                        am: preferredTimesAM,
                      }),
                      ...(preferredTimesPM.length && {
                        pm: preferredTimesPM,
                      }),
                    },
                    dogAtProperty: dog === 'true' ? true : false,
                    comments: this.state.comments,
                    jobs: jobs,
                    isolating: customerIsolating,
                    dropIn: dropIn,
                  };
                  createWorkRequest(data);
                }}
              >
                {(props) => {
                  const {
                    values,
                    handleSubmit,
                    handleChange,
                    isValid,
                    setFieldValue,
                  } = props;
                  return (
                    <form>
                      <Typography
                        variant="body1"
                        className={classes.jobCommentsLabel}
                      >
                        {getString(stringsComponent, 'CONFIRM_STEP_LABEL')}
                      </Typography>
                      <FormikTextField
                        name="comments"
                        value={values.comments
                          .replace('|', '')
                          .substring(0, overallCommentFieldMaxLength)}
                        label={getString(
                          stringsComponent,
                          'CONFIRM_STEP_PLACEHOLDER'
                        )}
                        maxLength={overallCommentFieldMaxLength}
                        clear={(e) => {
                          this.handleClear(setFieldValue, 'comments', e);
                        }}
                        classes={{
                          label: classes.jobCommentsInput,
                          input: classes.jobCommentsInput,
                        }}
                      />
                      <Typography
                        variant="body2"
                        className={classes.jobCommentsHelpText}
                      >
                        {getStringWithBreaks(
                          stringsComponent,
                          'CONFIRM_STEP_HELP'
                        )}
                      </Typography>
                      <Typography
                        variant="body2"
                        className={classes.jobCommentsHelpText}
                      >
                        <span
                          dangerouslySetInnerHTML={{
                            __html: getString(
                              stringsComponent,
                              'CONFIRM_STEP_HELP_LIST'
                            ),
                          }}
                        />
                      </Typography>
                      <Typography
                        variant="body2"
                        className={classes.jobCommentsHelpText}
                      >
                        <ReplaceContact
                          content={getString(
                            stringsComponent,
                            'CONFIRM_STEP_TEXT'
                          )}
                          action={contactAction}
                          forceEnglish={true}
                          isLink={true}
                        />
                      </Typography>
                      <Typography
                        variant="body2"
                        className={classes.jobCommentsTermsText}
                      >
                        <ReplaceMaintenanceTerms
                          content={getString(
                            stringsComponent,
                            'NEW_REQUEST_DIALOG_TERMS'
                          )}
                          action={this.handleTermsDialogToggle}
                        />
                      </Typography>
                      {this.buildButtons(
                        handleSubmit,
                        () => {
                          this.handlePrevious(
                            previous,
                            'comments',
                            values.comments,
                            overallCommentFieldMaxLength
                          );
                        },
                        isValid,
                        push,
                        step,
                        'Submit'
                      )}
                    </form>
                  );
                }}
              </Formik>
            </div>
          }
        />
      </React.Fragment>
    );
  }

  render() {
    const { classes, onError, failureText, contactAction } = this.props;
    const { isLoading } = this.state;

    return (
      <div className="App">
        <Card className="Card">
          <LoaderProgress show={isLoading} />
          {this.state.hasError && (
            <ErrorDialog logout={onError} text={failureText} />
          )}
          <BaseDialog
            open={this.state.termsDialogOpen}
            icon={ReportProblemIcon}
            buttonAction={this.handleTermsDialogToggle}
            buttonLabel={getString(stringsComponent, 'DIALOG_CLOSE_BUTTON')}
            title={getString(stringsComponent, 'TERMS_DIALOG_TITLE')}
            content={
              <ReplaceContact
                content={portalContent.MAINTENANCE_TERMS}
                action={contactAction}
                forceEnglish={true}
                isLink={true}
              />
            }
            contentWrap={false}
            isHTML={true}
          />

          <Wizard>
            <Steps>
              <Step
                id="where"
                render={({ next, push, step }) =>
                  this.renderWhereStep(next, push, step)
                }
              />
              <Step
                id="what"
                render={({ next, previous, push, step }) =>
                  this.renderWhatStep(next, push, step, previous)
                }
              />
              <Step
                id="issue"
                render={({ next, previous, push, step, go }) =>
                  this.renderIssueStep(next, push, step, previous, go)
                }
              />
              <Step
                id="why"
                render={({ next, previous, push, step }) =>
                  this.renderWhyStep(next, push, step, previous)
                }
              />
              <Step
                id="jobPhotos"
                render={({ next, previous, push, step }) =>
                  this.renderPhotoStep(next, push, step, previous)
                }
              />
              <Step
                id="jobComments"
                render={({ next, previous, push, step }) =>
                  this.renderJobCommentsStep(next, push, step, previous)
                }
              />
              <Step
                id="jobSummary"
                render={({ next, previous, push, step }) =>
                  this.renderJobSummaryStep(next, push, step, previous)
                }
              />
              <Step
                id="preferredTimes"
                render={({ next, previous, push, step }) =>
                  this.renderTimesStep(next, push, step, previous)
                }
              />
              <Step
                id="pets"
                render={({ next, previous, go }) =>
                  this.renderPetsStep(next, previous, go)
                }
              />
              <Step
                id="comments"
                render={({ next, previous, push, step }) =>
                  this.renderCommentsStep(push, step, previous)
                }
              />
            </Steps>
          </Wizard>
        </Card>
      </div>
    );
  }
}

CreateRequestForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onError: PropTypes.func.isRequired,
  failureText: PropTypes.object.isRequired,
  spaces: PropTypes.array.isRequired,
  setUnsaved: PropTypes.func.isRequired,
  contactAction: PropTypes.func.isRequired,
  createWorkRequest: PropTypes.func.isRequired,
  clearRequestCreated: PropTypes.func.isRequired,
  openWorkRequests: PropTypes.array,
  customerIsolating: PropTypes.bool.isRequired,
  gaEvent: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  createdWorkRequests: state.properties.createdWorkRequests,
  requestCreated: state.properties.createdWorkRequests.requestCreated,
  tenancy: state.customer.tenancy,
});

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(CreateRequestForm)
);
